<div class="sft-root">
    <div class="sft-page">
        <header class="nf-page-header">
            <button type="button" class="nf-page-header__back" (click)="back()">
                <svg aria-hidden="true" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor"
                    stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 6l-6 6 6 6" /></svg>
                {{ backLabel }}
            </button>
            <div class="nf-page-header__titlerow"><h1 class="nf-page-header__title">{{ headerTitle }}</h1></div>
            <p class="nf-page-header__subtitle">{{ headerSubtitle }}</p>
        </header>

        <div class="sft-grid">
            <!-- LEFT: the service cards the operator builds -->
            <div class="sft-main">
                @for (s of services; track $index) {
                <div class="sft-svc" [class.sft-open]="creating || s.open" [class.sft-done]="finished && s.state === 'done'"
                    [class.sft-err]="finished && s.state === 'error'" [class.sft-added]="s.justAdded">
                    <div class="sft-svc__head" (click)="toggleOpen(s)">
                        @if (started) {
                        <!-- Creation state: a status badge leads, and the completed steps tuck behind the chevron. -->
                        <span class="sft-svc__badge" [attr.data-state]="s.state">
                            @if (s.state === 'done') {
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12l5 5 9-11" /></svg>
                            } @else if (s.state === 'error') {
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M6 6l12 12M18 6L6 18" /></svg>
                            } @else if (s.state === 'creating') {
                            <span class="sft-spinner"></span>
                            } @else { <span class="sft-pdot"></span> }
                        </span>
                        } @else {
                        <span class="sft-svc__chev">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"
                                stroke-linecap="round" stroke-linejoin="round"><path d="M9 6l6 6-6 6" /></svg>
                        </span>
                        }
                        <span class="sft-svc__main">
                            <span class="sft-svc__name">{{ s.name || 'Untitled service' }}</span>
                            <span class="sft-svc__sum">
                                @if (started) {
                                {{ outcomeLine(s) }}
                                } @else {
                                <b>{{ accessPrimary(s) }}</b>
                                @if (accessMoreCount(s) > 0) {
                                <button type="button" class="sft-moreflag" (click)="toggleMorePopover(s, $event)">+{{ accessMoreCount(s) }} more</button>
                                }
                                <span class="sft-sumarrow">&rarr;</span><span class="sft-sumhost">{{ hostSummary(s) }}</span>
                                }
                            </span>
                        </span>
                        @if (started) {
                        <span class="sft-svc__status" [attr.data-state]="s.state">{{ statusLabel(s) }}</span>
                        <span class="sft-svc__chev sft-svc__chev--end" title="Show steps">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"
                                stroke-linecap="round" stroke-linejoin="round"><path d="M9 6l6 6-6 6" /></svg>
                        </span>
                        }
                        @if (services.length > 1 && !started) {
                        <button type="button" class="sft-svc__rm" title="Remove this service"
                            (click)="$event.stopPropagation(); removeService(s)">
                            <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor"
                                stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3" /></svg>
                        </button>
                        }
                        @if (s.morePopoverOpen) {
                        <div class="sft-flagpop sft-flagpop--abs" (click)="stop($event)">
                            <div class="sft-flagpop__hd">Accessing addresses</div>
                            @for (a of s.addresses; track a) { <div class="sft-flagpop__row">{{ a }}</div> }
                        </div>
                        }
                    </div>

                    <div class="sft-svc__body">
                        @if (!started) {
                        <!-- Service details -->
                        <div class="sft-cfg sft-cfg--det">
                            <div class="sft-field sft-first"><span class="sft-label">Name</span>
                                <input class="sft-input" [(ngModel)]="s.name" placeholder="Service name" /></div>
                            <div class="sft-field"><span class="sft-label">Attributes</span>
                                <app-token-combo wrap [maxVisibleChips]="12" allowCustom chipOptions [filterSuggestionsLocally]="true"
                                    [searchDelay]="0" [(ngModel)]="s.attributes" [suggestions]="serviceSuggestions" keepChosenVisible
                                    [toneFor]="attrTone" [normalizeToken]="normalizeAttrToken"
                                    placeholder="Add an attribute"></app-token-combo></div>
                        </div>

                        <!-- Accessing -->
                        <div class="sft-cfg sft-cfg--acc">
                            <div class="sft-cfg__t">Accessing</div>
                            <p class="sft-cfg__d">How clients connect to the service, and what identities can connect.</p>
                            <span class="sft-label">Type</span>
                            <div class="nf-option-cards" role="radiogroup">
                                <button type="button" class="nf-option-card" [class.selected]="s.accessMode === 'address'"
                                    role="radio" [attr.aria-checked]="s.accessMode === 'address'"
                                    (click)="setAccessMode(s, 'address')"><span class="nf-option-card__mark"></span>
                                    <span class="nf-option-card__icon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9" /><path d="M3 12h18" /><ellipse cx="12" cy="12" rx="4" ry="9" /></svg></span>
                                    <span class="nf-option-card__text"><span class="nf-option-card__titlerow"><span class="nf-option-card__title">Address</span></span>
                                        <span class="nf-option-card__detail">IP, CIDR, domain, Ziti name</span></span></button>
                                <button type="button" class="nf-option-card" [class.selected]="s.accessMode === 'sdk'"
                                    role="radio" [attr.aria-checked]="s.accessMode === 'sdk'"
                                    (click)="setAccessMode(s, 'sdk')"><span class="nf-option-card__mark"></span>
                                    <span class="nf-option-card__icon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M8.5 7.5 3.5 12l5 4.5" /><path d="M15.5 7.5 20.5 12l-5 4.5" /><path d="M13.6 5.5l-3.2 13" /></svg></span>
                                    <span class="nf-option-card__text"><span class="nf-option-card__titlerow"><span class="nf-option-card__title">SDK</span></span>
                                        <span class="nf-option-card__detail">Client dials via the Ziti SDK</span></span></button>
                            </div>
                            <div class="sft-grp">
                            @if (s.accessMode === 'address') {
                            <div class="sft-field sft-first"><span class="sft-label">Addresses</span>
                                <app-token-combo wrap [maxVisibleChips]="12" allowCustom chipOptions [filterSuggestionsLocally]="true"
                                    [(ngModel)]="s.addresses" (ngModelChange)="onAddressesChange(s)"
                                    [suggestionGroups]="observedAddressGroups" [showToggle]="observedAddressGroups.length > 0" keepChosenVisible
                                    placeholder="Add IP, CIDR, or domain"></app-token-combo></div>
                            <div class="sft-field"><span class="sft-label">Ports</span>
                                <app-token-combo wrap [maxVisibleChips]="12" allowCustom chipOptions [filterSuggestionsLocally]="true"
                                    [(ngModel)]="s.ports" (ngModelChange)="onPortsChange(s)"
                                    [suggestionGroups]="observedPortGroups" [showToggle]="observedPortGroups.length > 0" keepChosenVisible
                                    placeholder="Add port"></app-token-combo></div>
                            <div class="sft-field"><span class="sft-label">Protocol</span>
                                <div class="sft-seg">
                                    <button type="button" [class.sft-on]="s.accessProtocol === 'tcp'" (click)="setAccessProtocol(s, 'tcp')">TCP</button>
                                    <button type="button" [class.sft-on]="s.accessProtocol === 'udp'" (click)="setAccessProtocol(s, 'udp')">UDP</button>
                                    <button type="button" [class.sft-on]="s.accessProtocol === 'both'" (click)="setAccessProtocol(s, 'both')">TCP/UDP</button>
                                </div></div>
                            } @else {
                            <div class="sft-fwd sft-slate"><span class="sft-fi">&lt;/&gt;</span><div>
                                <div class="sft-ft">Dialed by the Ziti SDK app</div>
                                <div class="sft-fs">No intercept address; the client dials the service by name.</div></div></div>
                            }
                            </div>
                            <div class="sft-grp">
                                <div class="sft-field"><span class="sft-label">Accessible by</span>
                                    <app-token-combo wrap [maxVisibleChips]="12" allowCustom chipOptions [filterSuggestionsLocally]="true"
                                        [(ngModel)]="s.dialAttributes" [suggestionGroups]="accessSuggestionGroups" keepChosenVisible
                                        [toneFor]="attrTone" [normalizeToken]="normalizeAttrToken"
                                        (search)="getIdentityNamedAttributes($event)"
                                        placeholder="Select identities or #roles to grant access"></app-token-combo></div>
                            </div>
                        </div>

                        <!-- Hosting -->
                        <div class="sft-cfg sft-cfg--host">
                            <div class="sft-cfg__t">Hosting</div>
                            <p class="sft-cfg__d">Where that traffic is delivered, and which identities host it.</p>
                            <span class="sft-label">Type</span>
                            <div class="nf-option-cards" role="radiogroup">
                                <button type="button" class="nf-option-card" [class.selected]="s.hostMode === 'address'"
                                    role="radio" [attr.aria-checked]="s.hostMode === 'address'"
                                    (click)="setHostMode(s, 'address')"><span class="nf-option-card__mark"></span>
                                    <span class="nf-option-card__icon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9" /><path d="M3 12h18" /><ellipse cx="12" cy="12" rx="4" ry="9" /></svg></span>
                                    <span class="nf-option-card__text"><span class="nf-option-card__titlerow"><span class="nf-option-card__title">Address</span></span>
                                        <span class="nf-option-card__detail">Delivered to a server</span></span></button>
                                <button type="button" class="nf-option-card" [class.selected]="s.hostMode === 'sdk'"
                                    role="radio" [attr.aria-checked]="s.hostMode === 'sdk'"
                                    (click)="setHostMode(s, 'sdk')"><span class="nf-option-card__mark"></span>
                                    <span class="nf-option-card__icon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M8.5 7.5 3.5 12l5 4.5" /><path d="M15.5 7.5 20.5 12l-5 4.5" /><path d="M13.6 5.5l-3.2 13" /></svg></span>
                                    <span class="nf-option-card__text"><span class="nf-option-card__titlerow"><span class="nf-option-card__title">SDK</span></span>
                                        <span class="nf-option-card__detail">The Ziti SDK app serves it</span></span></button>
                            </div>
                            <div class="sft-grp">
                            @if (s.hostMode === 'address') {
                            <div class="sft-dim sft-dim--first"><span class="sft-dim__lbl">Address</span>
                                <div class="sft-seg">
                                    <button type="button" [class.sft-on]="s.fwdAddress" (click)="setFwd(s, 'Address', true)">Forward</button>
                                    <button type="button" [class.sft-on]="!s.fwdAddress" (click)="setFwd(s, 'Address', false)">Fixed</button>
                                </div>
                                <div class="sft-dim__val">
                                    @if (!s.fwdAddress) { <input class="sft-input" [(ngModel)]="s.addressVal" style="max-width:11rem" /> }
                                </div>
                            </div>
                            <div class="sft-dim"><span class="sft-dim__lbl">Port</span>
                                <div class="sft-seg">
                                    <button type="button" [class.sft-on]="s.fwdPort" (click)="setFwd(s, 'Port', true)">Forward</button>
                                    <button type="button" [class.sft-on]="!s.fwdPort" (click)="setFwd(s, 'Port', false)">Fixed</button>
                                </div>
                                <div class="sft-dim__val">
                                    @if (!s.fwdPort) { <input class="sft-input" [(ngModel)]="s.portVal" style="max-width:6rem" /> }
                                </div>
                            </div>
                            <div class="sft-dim"><span class="sft-dim__lbl">Protocol</span>
                                <div class="sft-seg">
                                    <button type="button" [class.sft-on]="s.fwdProtocol" (click)="setFwd(s, 'Protocol', true)">Forward</button>
                                    <button type="button" [class.sft-on]="!s.fwdProtocol" (click)="setFwd(s, 'Protocol', false)">Fixed</button>
                                </div>
                                <div class="sft-dim__val">
                                    @if (!s.fwdProtocol) {
                                    <select class="sft-input" style="max-width:6rem" [(ngModel)]="s.protocolVal">
                                        <option value="tcp">TCP</option>
                                        <option value="udp">UDP</option>
                                    </select>
                                    }
                                </div>
                            </div>
                            <button type="button" class="sft-more" (click)="toggleMore(s)">
                                {{ s.moreOpen ? '&#9662;' : '&#9656;' }} Allowed ranges &amp; source addresses
                            </button>
                            @if (s.moreOpen) {
                            <div class="sft-morebody">
                                <div class="sft-field sft-first"><span class="sft-label">Allowed addresses</span>
                                    <app-token-combo wrap [maxVisibleChips]="12" allowCustom chipOptions [filterSuggestionsLocally]="true"
                                        [(ngModel)]="s.allowedAddresses" placeholder="Defaults to the dialed address"></app-token-combo></div>
                                <div class="sft-field"><span class="sft-label">Allowed port ranges</span>
                                    <app-token-combo wrap [maxVisibleChips]="12" allowCustom chipOptions [filterSuggestionsLocally]="true"
                                        [(ngModel)]="s.allowedPorts" placeholder="Defaults to the dialed port"></app-token-combo></div>
                                <div class="sft-field"><span class="sft-label">Allowed protocols</span>
                                    <div class="sft-toggles">
                                        <button type="button" class="sft-toggle" [class.sft-on]="s.allowedProtocols.includes('tcp')" (click)="toggleAllowedProtocol(s, 'tcp')">TCP</button>
                                        <button type="button" class="sft-toggle" [class.sft-on]="s.allowedProtocols.includes('udp')" (click)="toggleAllowedProtocol(s, 'udp')">UDP</button>
                                    </div></div>
                                <div class="sft-field">
                                    <div class="sft-fhead"><span class="sft-label sft-label--inline">Allowed source addresses</span>
                                        @if (selectedSourceIps.length && !allSourceAddressesApplied(s)) {
                                        <button type="button" class="sft-fhead__act" (click)="applyAllSourceAddresses(s)">Apply all {{ selectedSourceIps.length }}</button>
                                        }
                                    </div>
                                    <app-token-combo wrap [maxVisibleChips]="12" allowCustom chipOptions [filterSuggestionsLocally]="true"
                                        [(ngModel)]="s.allowedSourceAddresses" [suggestionGroups]="sourceSuggestionGroups" keepChosenVisible
                                        [showToggle]="sourceSuggestionGroups.length > 0"
                                        placeholder="Any source, or pick the observed sources"></app-token-combo></div>
                            </div>
                            }
                            } @else {
                            <div class="sft-fwd sft-slate"><span class="sft-fi">&lt;/&gt;</span><div>
                                <div class="sft-ft">Hosted by the Ziti SDK app</div>
                                <div class="sft-fs">A hosting app serves the endpoint; no host address is set.</div></div></div>
                            }
                            </div>
                            <div class="sft-grp">
                                <div class="sft-field"><span class="sft-label">Hosted by</span>
                                    <app-token-combo wrap [maxVisibleChips]="12" allowCustom chipOptions [filterSuggestionsLocally]="true"
                                        [(ngModel)]="s.bindAttributes" [suggestionGroups]="hostSuggestionGroups" keepChosenVisible
                                        [toneFor]="attrTone" [normalizeToken]="normalizeAttrToken"
                                        (search)="getIdentityNamedAttributes($event)"
                                        placeholder="Select identities or #roles that can host"></app-token-combo></div>
                            </div>
                        </div>
                        } @else {
                        <!-- Creation progress -->
                        <ul class="sft-progress">
                            @for (st of s.statuses; track st.step) {
                            <li class="sft-progress__item" [attr.data-status]="st.status">
                                <span class="sft-progress__icon">
                                    @if (st.status === 'success') {
                                    <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor"
                                        stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12l5 5 9-11" /></svg>
                                    } @else if (st.status === 'error') {
                                    <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor"
                                        stroke-width="2.4" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18" /></svg>
                                    } @else if (st.status === 'in_progress') {
                                    <span class="sft-spinner"></span>
                                    } @else { <span class="sft-pdot"></span> }
                                </span>
                                <span class="sft-progress__text"><span class="sft-progress__step">{{ st.step }}</span>
                                    @if (st.status === 'error' && st.message) { <span class="sft-progress__msg">{{ st.message }}</span> }</span>
                            </li>
                            }
                            @if (!s.statuses.length) {
                            <li class="sft-progress__item"><span class="sft-progress__icon"><span class="sft-pdot"></span></span>
                                <span class="sft-progress__text"><span class="sft-progress__step">Waiting to start</span></span></li>
                            }
                        </ul>
                        }
                    </div>
                </div>
                }
            </div>

            <!-- RIGHT: selected traffic, coverage, outcome, action -->
            <aside class="sft-aside">
                <section class="nf-panel sft-ref">
                    <p class="sft-ref__t">Selected traffic</p>
                    <!-- one pool chip, shared by the inline rows and the "show all" popovers -->
                    <ng-template #chip let-x let-id="id" let-applied="applied">
                        <span class="sft-rchip" [class.sft-rchip--id]="id" [class.sft-rchip--covered]="applied"
                            [title]="applied ? 'In a service' : 'Not placed yet'">
                            @if (applied) { <svg class="sft-rchip__check" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12l5 5 9-11" /></svg> }
                            {{ x }}</span>
                    </ng-template>
                    @if (selectedSourceIdentities.length || selectedSourceIps.length) {
                    <div class="sft-ref__grp">
                        <p class="sft-ref__gh">Source</p>
                        @if (selectedSourceIdentities.length) {
                        <div class="sft-ref__row"><span class="sft-ref__k">Identities</span>
                            <span class="sft-ref__v">
                                @for (id of visibleChips(selectedSourceIdentities); track id) {
                                <ng-container *ngTemplateOutlet="chip; context: { $implicit: id, id: true, applied: isSourceIdentityApplied(id) }"></ng-container>
                                }
                                @if (selectedSourceIdentities.length > chipCap) {
                                <button type="button" class="sft-ref__more" (click)="toggleRowPopover('srcId', $event)">Show all {{ selectedSourceIdentities.length }}</button>
                                @if (popoverRow === 'srcId') {
                                <div class="sft-refpop" (click)="stop($event)">
                                    <div class="sft-refpop__hd">All {{ selectedSourceIdentities.length }} identities</div>
                                    <div class="sft-refpop__chips">
                                        @for (id of selectedSourceIdentities; track id) {
                                        <ng-container *ngTemplateOutlet="chip; context: { $implicit: id, id: true, applied: isSourceIdentityApplied(id) }"></ng-container>
                                        }
                                    </div>
                                </div>
                                }
                                }
                            </span></div>
                        }
                        @if (selectedSourceIps.length) {
                        <div class="sft-ref__row"><span class="sft-ref__k">Addresses</span>
                            <span class="sft-ref__v">
                                @for (ip of visibleChips(selectedSourceIps); track ip) {
                                <ng-container *ngTemplateOutlet="chip; context: { $implicit: ip, id: false, applied: isSourceAddressApplied(ip) }"></ng-container>
                                }
                                @if (selectedSourceIps.length > chipCap) {
                                <button type="button" class="sft-ref__more" (click)="toggleRowPopover('srcAddr', $event)">Show all {{ selectedSourceIps.length }}</button>
                                @if (popoverRow === 'srcAddr') {
                                <div class="sft-refpop" (click)="stop($event)">
                                    <div class="sft-refpop__hd">All {{ selectedSourceIps.length }} addresses</div>
                                    <div class="sft-refpop__chips">
                                        @for (ip of selectedSourceIps; track ip) {
                                        <ng-container *ngTemplateOutlet="chip; context: { $implicit: ip, id: false, applied: isSourceAddressApplied(ip) }"></ng-container>
                                        }
                                    </div>
                                </div>
                                }
                                }
                            </span></div>
                        }
                    </div>
                    }
                    <div class="sft-ref__grp">
                        <p class="sft-ref__gh">Destination</p>
                        <div class="sft-ref__row"><span class="sft-ref__k">Addresses</span>
                            <span class="sft-ref__v">
                                @for (a of visibleChips(observedAddresses); track a) {
                                <ng-container *ngTemplateOutlet="chip; context: { $implicit: a, id: false, applied: isAddressApplied(a) }"></ng-container>
                                }
                                @if (observedAddresses.length > chipCap) {
                                <button type="button" class="sft-ref__more" (click)="toggleRowPopover('dstAddr', $event)">Show all {{ observedAddresses.length }}</button>
                                @if (popoverRow === 'dstAddr') {
                                <div class="sft-refpop" (click)="stop($event)">
                                    <div class="sft-refpop__hd">All {{ observedAddresses.length }} addresses</div>
                                    <div class="sft-refpop__chips">
                                        @for (a of observedAddresses; track a) {
                                        <ng-container *ngTemplateOutlet="chip; context: { $implicit: a, id: false, applied: isAddressApplied(a) }"></ng-container>
                                        }
                                    </div>
                                </div>
                                }
                                }
                            </span></div>
                        <div class="sft-ref__row"><span class="sft-ref__k">Ports</span>
                            <span class="sft-ref__v">
                                @for (p of visibleChips(observedPorts); track p) {
                                <ng-container *ngTemplateOutlet="chip; context: { $implicit: p, id: false, applied: isPortApplied(p) }"></ng-container>
                                }
                                @if (observedPorts.length > chipCap) {
                                <button type="button" class="sft-ref__more" (click)="toggleRowPopover('ports', $event)">Show all {{ observedPorts.length }}</button>
                                @if (popoverRow === 'ports') {
                                <div class="sft-refpop" (click)="stop($event)">
                                    <div class="sft-refpop__hd">All {{ observedPorts.length }} ports</div>
                                    <div class="sft-refpop__chips">
                                        @for (p of observedPorts; track p) {
                                        <ng-container *ngTemplateOutlet="chip; context: { $implicit: p, id: false, applied: isPortApplied(p) }"></ng-container>
                                        }
                                    </div>
                                </div>
                                }
                                }
                            </span></div>
                        @if (selectedHostIdentities.length) {
                        <div class="sft-ref__row"><span class="sft-ref__k">Host</span>
                            <span class="sft-ref__v">
                                @for (h of visibleChips(selectedHostIdentities); track h) {
                                <ng-container *ngTemplateOutlet="chip; context: { $implicit: h, id: true, applied: isHostIdentityApplied(h) }"></ng-container>
                                }
                                @if (selectedHostIdentities.length > chipCap) {
                                <button type="button" class="sft-ref__more" (click)="toggleRowPopover('host', $event)">Show all {{ selectedHostIdentities.length }}</button>
                                @if (popoverRow === 'host') {
                                <div class="sft-refpop" (click)="stop($event)">
                                    <div class="sft-refpop__hd">All {{ selectedHostIdentities.length }} identities</div>
                                    <div class="sft-refpop__chips">
                                        @for (h of selectedHostIdentities; track h) {
                                        <ng-container *ngTemplateOutlet="chip; context: { $implicit: h, id: true, applied: isHostIdentityApplied(h) }"></ng-container>
                                        }
                                    </div>
                                </div>
                                }
                                }
                            </span></div>
                        }
                    </div>

                </section>

                <section class="nf-panel sft-ref">
                    <p class="sft-podttl">Coverage &amp; result</p>
                    @if (totalSegments) {
                    <div class="sft-covblock">
                        <div class="sft-cov">
                            <span class="sft-cov__label">Coverage
                                <button type="button" class="sft-info" (click)="toggleCovInfo($event)"
                                    [attr.aria-expanded]="covInfoOpen" aria-label="What is a path?">
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                        stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10" /><path d="M12 16v-4" /><path d="M12 8h.01" /></svg>
                                </button>
                            </span>
                            @if (coverageReady) {
                            <span class="v">{{ covNumerator }} of {{ covDenominator }} {{ coverageUnit }} covered</span>
                            } @else {
                            <span class="v sft-cov__loading">Calculating&hellip;</span>
                            }
                        </div>
                        @if (covInfoOpen) {
                        <div class="sft-infopop" (click)="stop($event)">Each path is one source reaching one destination address:port.</div>
                        }
                        <div class="sft-covbar" [class.is-partial]="coveragePercent < 100"><span [style.width.%]="coveragePercent"></span></div>
                        <button type="button" class="sft-covlink" (click)="openCoverage()" title="View coverage flow map">
                            View flow map
                            <svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor"
                                stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 6l6 6-6 6" /></svg>
                        </button>
                    </div>
                    <div class="sft-ref__div"></div>
                    }
                    <div class="sft-sumline"><span>Services</span><span class="v">{{ services.length }}</span></div>
                    <div class="sft-sumline"><span>Total resources</span><span class="v">{{ totalResources }}</span></div>

                    @if (!started) {
                    <button type="button" class="sft-addsvc" (click)="addService()">
                        <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.2"
                            stroke-linecap="round" stroke-linejoin="round"><path d="M12 5v14M5 12h14" /></svg>
                        Add another service
                    </button>
                    }

                    @if (finished) {
                    <button type="button" class="nf-btn nf-btn--primary sft-create" (click)="done()">{{ doneLabel }}</button>
                    @if (canCreateSourceIdentities) {
                    <button type="button" class="sft-secondary" (click)="createSourceIdentities()">
                        Create identities for sources
                    </button>
                    }
                    <button type="button" class="sft-secondary" (click)="viewServices()">View services</button>
                    } @else {
                    <button type="button" class="nf-btn nf-btn--primary sft-create" [disabled]="creating || !canCreate" (click)="create()">
                        {{ creating ? 'Creating...' : createLabel }}
                    </button>
                    }
                </section>
            </aside>
        </div>
    </div>
</div>
